module.exports = __webpack_public_path__ + "static/img/17b.f557d04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/17b.png
// module id = V0W4
// module chunks = 1